const translation = {
  custom: 'カスタマイズ',
  upgradeTip: {
    prefix: 'プランをアップグレードして',
    suffix: 'ブランドをカスタマイズしましょう。',
  },
  webapp: {
    title: 'WebAppブランドのカスタマイズ',
    removeBrand: 'Powered by Difyを削除',
    changeLogo: 'Powered byブランド画像を変更',
    changeLogoTip: '最小サイズ40x40pxのSVGまたはPNG形式',
  },
  app: {
    title: 'アプリヘッダーブランドのカスタマイズ',
    changeLogoTip: '最小サイズ80x80pxのSVGまたはPNG形式',
  },
  upload: 'アップロード',
  uploading: 'アップロード中',
  uploadedFail: '画像のアップロードに失敗しました。再度アップロードしてください。',
  change: '変更',
  apply: '適用',
  restore: 'デフォルトに戻す',
  customize: {
    contactUs: 'お問い合わせ',
    prefix: 'アプリ内のブランドロゴをカスタマイズするには、',
    suffix: 'エンタープライズ版にアップグレードしてください。',
  },
}

export default translation
